import React from 'react';
import PropTypes from 'prop-types';
import { Field } from '@ontruck/orc';

const t = {
  placeholder: 'Search',
  maskedPlaceholder: 'S/J000000',
};

const maskedProps = {
  formatChars: {
    9: '[0-9]',
    A: '[SsJj0-9]',
  },
  mask: 'A999999999',
  maskChar: '',
};

const SearchField = ({
  error,
  onKeyUp,
  className,
  onFocus,
  onBlur,
  onChange,
  value,
  simplified,
}) => (
  <div className={className} data-testid="search-field">
    <Field
      size="M"
      label=""
      id="search_field"
      name="search_field"
      value={value}
      labelType="hidden"
      placeholder={simplified ? t.placeholder : t.maskedPlaceholder}
      onFocus={onFocus}
      onBlur={onBlur}
      onChange={onChange}
      onKeyUp={onKeyUp}
      invalid={error}
      maskedProps={simplified ? null : maskedProps}
    />
  </div>
);

SearchField.propTypes = {
  error: PropTypes.bool,
  onKeyUp: PropTypes.func,
  className: PropTypes.string,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  value: PropTypes.string,
};

export default SearchField;
